/* HOUSE OF HESTIA — theme.js */
(function () {
  'use strict';

  /* ---------- header: dropdown + search + mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-dropdown-toggle]');
    document.querySelectorAll('.nav-item.is-open').forEach(function (el) {
      if (!toggle || el !== toggle.parentElement) el.classList.remove('is-open');
    });
    if (toggle) toggle.parentElement.classList.toggle('is-open');

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var wrap = searchToggle.closest('.header-search');
      wrap.classList.toggle('is-open');
      if (wrap.classList.contains('is-open')) wrap.querySelector('input').focus();
    }

    if (e.target.closest('[data-menu-open]')) document.querySelector('.mobile-menu').classList.add('is-open');
    if (e.target.closest('[data-menu-close]')) document.querySelector('.mobile-menu').classList.remove('is-open');
  });


  /* ---------- sticky desktop nav row: shadow + small logo once pinned ---------- */
  (function () {
    var header = document.querySelector('.site-header--sticky');
    if (!header || !('IntersectionObserver' in window)) return;
    var row = header.querySelector('.nav-row');
    var logo = header.querySelector('.site-header__logo');
    if (!row || !logo) return;
    new IntersectionObserver(function (entries) {
      row.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(logo);
  })();
  /* ---------- compact bar: slides in past the header; behavior is a setting ---------- */
  (function () {
    var bar = document.querySelector('[data-compact-bar]');
    var header = document.querySelector('.site-header');
    if (!bar || !header) return;
    var mobile = window.matchMedia('(max-width: 860px)');
    var mode = bar.dataset.stickyMode || 'idle';
    var IDLE_DELAY = 1600;
    var idleTimer, lastY = 0;

    function onScroll() {
      if (!mobile.matches) return;
      var y = window.scrollY;
      var past = y > header.offsetHeight;
      var menuOpen = document.querySelector('.mobile-menu.is-open');

      if (!past) {
        bar.classList.remove('is-visible');
      } else if (mode === 'always' || menuOpen) {
        bar.classList.add('is-visible');
      } else if (mode === 'scrolldir') {
        if (y < lastY - 2) bar.classList.add('is-visible');
        else if (y > lastY + 2) bar.classList.remove('is-visible');
      } else { /* idle */
        bar.classList.add('is-visible');
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { bar.classList.remove('is-visible'); }, IDLE_DELAY);
      }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (mode === 'idle') {
      document.addEventListener('touchstart', function () {
        if (mobile.matches && window.scrollY > header.offsetHeight) bar.classList.add('is-visible');
      }, { passive: true });
    }
  })();

  /* ---------- quantity selectors (works on product + cart) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart helpers ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function addToCart(id, qty, properties) {
    var payload = { id: id, quantity: qty || 1 };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  /* card quick add — [data-quick-add="<variant id>"] */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    addToCart(btn.dataset.quickAdd, 1).then(function () {
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1600);
    }).catch(function (err) {
      btn.textContent = (err && err.description) ? 'Sold out' : 'Error';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
    });
  });

  /* ---------- product form: variant -> price + id ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var priceEls = document.querySelectorAll('[data-product-price]');
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('[data-atc]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    var msgField = form.querySelector('[data-postcard-message]');
    var msgCount = form.querySelector('[data-postcard-count]');

    if (msgField && msgCount) {
      var setCount = function () { msgCount.textContent = msgField.value.length; };
      msgField.addEventListener('input', setCount);
      setCount();
    }

    function postcardProps() {
      if (msgField && msgField.value.trim()) {
        var name = msgField.getAttribute('name').replace(/^properties\[|\]$/g, '');
        var p = {}; p[name] = msgField.value.trim();
        return p;
      }
      return null;
    }

    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) + '/-';
    }
    function currentVariant() {
      var opts = Array.prototype.map.call(form.querySelectorAll('input[type="radio"]:checked'), function (r) { return r.value; });
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }
    form.addEventListener('change', function () {
      var v = currentVariant();
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      [atc, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = parseInt((form.querySelector('input[name="quantity"]') || { value: 1 }).value, 10);
      atc.disabled = true;
      addToCart(idInput.value, qty, postcardProps()).then(function () {
        atc.textContent = 'Added ✓';
        setTimeout(function () { atc.textContent = atc.dataset.labelAdd; atc.disabled = false; }, 1600);
      }).catch(function () {
        atc.textContent = 'Error';
        setTimeout(function () { atc.textContent = atc.dataset.labelAdd; atc.disabled = false; }, 1600);
      });
    });
  });

  /* ---------- cart page: line quantity / remove ---------- */
  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { window.location.reload(); });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) changeLine(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10));
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.lineRemove, 10), 0); }
  });

  /* ---------- cart page: discount codes (cart/update.js `discount` param) ---------- */
  (function () {
    var box = document.querySelector('[data-discount-box]');
    if (!box) return;
    var input = box.querySelector('[data-discount-input]');
    var applyBtn = box.querySelector('[data-discount-apply]');
    var msg = box.querySelector('[data-discount-msg]');

    function appliedCodes() {
      return (box.dataset.applied || '').split(',').filter(Boolean);
    }
    var toggle = box.querySelector('[data-discount-toggle]');
    var row = box.querySelector('[data-discount-row]');
    if (toggle && row) toggle.addEventListener('click', function () {
      row.hidden = !row.hidden;
      toggle.setAttribute('aria-expanded', !row.hidden);
      if (!row.hidden) input.focus();
    });
    function setMsg(text, ok) {
      msg.textContent = text;
      msg.hidden = !text;
      msg.classList.toggle('is-ok', !!ok);
    }
    function postDiscount(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { return r.json(); });
    }

    applyBtn.addEventListener('click', function () {
      var code = (input.value || '').trim();
      if (!code) return;
      var codes = appliedCodes();
      if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        setMsg('Code already applied.');
        return;
      }
      applyBtn.disabled = true;
      setMsg('');
      postDiscount(codes.concat(code)).then(function (cart) {
        var entry = (cart.discount_codes || []).find(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        });
        if (entry && entry.applicable) {
          window.location.reload();
        } else {
          /* invalid / not applicable — strip it back out so it doesn't linger at checkout */
          postDiscount(codes).then(function () {
            setMsg('That code isn\u2019t valid or doesn\u2019t apply to this cart.');
            applyBtn.disabled = false;
          });
        }
      }).catch(function () {
        setMsg('Couldn\u2019t apply the code. Try again.');
        applyBtn.disabled = false;
      });
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyBtn.click(); }
    });

    box.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-discount-remove]');
      if (!rm) return;
      rm.disabled = true;
      var remaining = appliedCodes().filter(function (c) { return c !== rm.dataset.discountRemove; });
      postDiscount(remaining).then(function () { window.location.reload(); });
    });
  })();

  /* ---------- PDP collapsible rows ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.pdp-acc__head');
    if (!head) return;
    var acc = head.closest('[data-acc]');
    var open = acc.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open);
  });

  /* ---------- sticky ATC bar: show once the real button scrolls away ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var actions = document.querySelector('.product-actions');
    var form = document.querySelector('[data-product-form]');
    if (!bar || !actions || !form || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* visible only when the buy box has scrolled above the viewport */
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(actions);
    var btn = bar.querySelector('[data-sticky-atc-btn]');
    btn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  })();

  /* ---------- cart: animate free-shipping fill on load ---------- */
  var shipFill = document.querySelector('[data-shipbar-fill]');
  if (shipFill) requestAnimationFrame(function () {
    requestAnimationFrame(function () { shipFill.style.width = shipFill.dataset.pct + '%'; });
  });

  /* ---------- scent-flip cards ---------- */
  document.addEventListener('click', function (e) {
    var flip = e.target.closest('[data-card-flip]');
    if (flip) {
      e.preventDefault();
      flip.closest('.product-card').classList.toggle('is-flipped');
      return;
    }
    var back = e.target.closest('.product-card__back');
    if (back && !e.target.closest('a')) back.closest('.product-card').classList.remove('is-flipped');
  });

  /* ---------- shoppable image hotspots ---------- */
  document.querySelectorAll('[data-hotspots]').forEach(function (root) {
    var card = root.querySelector('[data-hotspot-card]');
    if (!card) return;
    var img = card.querySelector('[data-hotspot-img]');
    var title = card.querySelector('[data-hotspot-title]');
    var price = card.querySelector('[data-hotspot-price]');
    var link = card.querySelector('[data-hotspot-link]');
    var add = card.querySelector('[data-hotspot-add]');

    function close() {
      card.hidden = true;
      root.querySelectorAll('.hotspot.is-active').forEach(function (h) { h.classList.remove('is-active'); });
    }
    root.addEventListener('click', function (e) {
      var spot = e.target.closest('[data-hotspot]');
      if (spot) {
        var wasActive = spot.classList.contains('is-active');
        close();
        if (wasActive) return; /* second tap closes */
        spot.classList.add('is-active');
        img.src = spot.dataset.img; img.alt = spot.dataset.title;
        title.textContent = spot.dataset.title;
        price.textContent = spot.dataset.price;
        link.href = spot.dataset.url;
        add.hidden = spot.dataset.available !== 'true';
        add.dataset.variantId = spot.dataset.variant;
        add.classList.remove('is-added');
        add.textContent = '+';
        card.hidden = false;
        return;
      }
      if (e.target.closest('[data-hotspot-close]')) close();
    });
    if (add) add.addEventListener('click', function () {
      add.disabled = true;
      addToCart(add.dataset.variantId, 1).then(function () {
        add.classList.add('is-added');
        add.textContent = '\u2713';
        setTimeout(function () { add.classList.remove('is-added'); add.textContent = '+'; add.disabled = false; }, 1600);
      }).catch(function () { add.textContent = '!'; add.disabled = false; });
    });
  });

  /* ---------- quick-add bottom sheet for multi-variant cards ---------- */
  (function () {
    var sheet, backdrop, state = null;

    function build() {
      backdrop = document.createElement('div');
      backdrop.className = 'qa-backdrop';
      sheet = document.createElement('div');
      sheet.className = 'qa-sheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-label', 'Choose options');
      document.body.appendChild(backdrop);
      document.body.appendChild(sheet);
      backdrop.addEventListener('click', closeSheet);
    }
    function openSheet() { document.body.classList.add('qa-open'); }
    function closeSheet() { document.body.classList.remove('qa-open'); }
    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) + '/-';
    }
    function currentVariant() {
      return state.product.variants.find(function (v) {
        return state.selected.every(function (val, i) { return v['option' + (i + 1)] === val; });
      });
    }
    function syncState() {
      var v = currentVariant();
      var priceEl = sheet.querySelector('.qa-sheet__price');
      var atc = sheet.querySelector('.qa-sheet__atc');
      if (v) {
        priceEl.textContent = money(v.price);
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
        atc.dataset.variantId = v.id;
      } else {
        atc.disabled = true;
        atc.textContent = 'UNAVAILABLE';
      }
    }
    function render(product) {
      state = { product: product, selected: product.options.map(function (o) { return o.values[0]; }) };
      var head = '<div class="qa-sheet__grab"></div><div class="qa-sheet__head">' +
        (product.featured_image ? '<img src="' + product.featured_image + '&width=120" alt="">' : '') +
        '<div><div class="qa-sheet__title">' + product.title + '</div><div class="qa-sheet__price"></div></div></div>';
      var opts = product.options.map(function (o, oi) {
        return '<div class="qa-option"><span class="qa-option__label">' + o.name + '</span><div class="qa-pills">' +
          o.values.map(function (val, vi) {
            return '<button type="button" class="qa-pill' + (vi === 0 ? ' is-selected' : '') + '" data-oi="' + oi + '" data-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      sheet.innerHTML = head + opts + '<button type="button" class="btn btn--maroon btn--block qa-sheet__atc">ADD TO CART</button>';
      syncState();

      sheet.querySelectorAll('.qa-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var oi = parseInt(pill.dataset.oi, 10);
          state.selected[oi] = pill.dataset.val;
          pill.parentElement.querySelectorAll('.qa-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          syncState();
        });
      });
      sheet.querySelector('.qa-sheet__atc').addEventListener('click', function () {
        var atc = this;
        atc.disabled = true;
        addToCart(atc.dataset.variantId, 1).then(function () {
          atc.textContent = 'Added \u2713';
          setTimeout(closeSheet, 700);
          setTimeout(function () { atc.textContent = 'ADD TO CART'; atc.disabled = false; }, 1100);
        }).catch(function () {
          atc.textContent = 'Error';
          setTimeout(function () { atc.textContent = 'ADD TO CART'; atc.disabled = false; }, 1600);
        });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      if (!sheet) build();
      sheet.innerHTML = '<div class="qa-sheet__grab"></div><div class="qa-sheet__title" style="text-align:center;padding:20px 0">Loading\u2026</div>';
      openSheet();
      fetch('/products/' + btn.dataset.quickView + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(render)
        .catch(function () { window.location.href = '/products/' + btn.dataset.quickView; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });
  })();

  /* ---------- bundle builder ---------- */
  document.querySelectorAll('[data-bundle]').forEach(function (root) {
    var size = parseInt(root.dataset.size, 10) || 3;
    var disc = parseFloat(root.dataset.discount) || 0;
    var picks = [];
    var slots = root.querySelector('[data-bundle-slots]');
    var status = root.querySelector('[data-bundle-status]');
    var total = root.querySelector('[data-bundle-total]');
    var openBtn = root.querySelector('[data-bundle-open]');
    var modal = root.querySelector('[data-bundle-modal]');
    var atc = root.querySelector('[data-bundle-atc]');
    var noteEl = root.querySelector('[data-bundle-note]');
    var modalSummary = root.querySelector('[data-bundle-modal-summary]');
    var ctaLabel = openBtn ? openBtn.textContent : 'Add box to cart';

    function money(c) { return 'Rs. ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) + '/-'; }

    function counts() {
      var byItem = {};
      picks.forEach(function (p) { byItem[p.pid] = (byItem[p.pid] || 0) + 1; });
      return byItem;
    }
    function refreshBadges() {
      var c = counts();
      root.querySelectorAll('[data-bundle-item]').forEach(function (item) {
        var badge = item.querySelector('[data-count]');
        var n = c[item.dataset.pid] || 0;
        if (badge) { badge.textContent = '\u00d7' + n; badge.hidden = n === 0; }
        item.querySelectorAll('.bundle__size').forEach(function (b) { b.classList.toggle('is-active', n > 0); });
      });
    }
    function sync() {
      slots.innerHTML = '';
      picks.forEach(function (p, i) {
        var wrap = document.createElement('span'); wrap.className = 'bundle__slot-wrap';
        var img = document.createElement('img'); img.className = 'bundle__slot'; img.src = p.img; img.alt = p.title;
        var x = document.createElement('button'); x.className = 'bundle__slot-x'; x.type = 'button';
        x.setAttribute('aria-label', 'Remove ' + p.title); x.innerHTML = '\u00d7';
        x.addEventListener('click', function () { picks.splice(i, 1); sync(); });
        wrap.appendChild(img); wrap.appendChild(x); slots.appendChild(wrap);
      });
      for (var i = picks.length; i < size; i++) {
        var e = document.createElement('span'); e.className = 'bundle__slot-empty'; slots.appendChild(e);
      }
      var left = size - picks.length;
      var full = left <= 0;
      root.classList.toggle('is-full', full);
      status.textContent = full ? 'Your box is ready \u2728' : 'Pick ' + left + ' more';
      var sub = picks.reduce(function (s, p) { return s + p.price; }, 0);
      if (!picks.length) { total.textContent = ''; }
      else if (disc > 0) {
        var dp = Math.round(sub * (1 - disc / 100));
        total.innerHTML = '<s>' + money(sub) + '</s>' + money(dp) +
          '<span class="save">save ' + money(sub - dp) + '</span>';
      } else { total.textContent = money(sub); }
      if (openBtn) openBtn.disabled = !full;
      refreshBadges();
      return full;
    }
    function summary() {
      var sub = picks.reduce(function (s, p) { return s + p.price; }, 0);
      var line = picks.length + ' candles \u00b7 ' + money(sub);
      if (disc > 0) { var dp = Math.round(sub * (1 - disc / 100)); line = picks.length + ' candles \u00b7 ' + money(dp) + ' (' + disc + '% off applied at checkout)'; }
      if (modalSummary) modalSummary.textContent = line;
    }
    function openModal() {
      if (picks.length !== size) return;
      summary();
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (noteEl) setTimeout(function () { noteEl.focus(); }, 350);
    }
    function closeModal() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }

    /* close + skip bound on the modal itself, so it keeps working after the
       modal is moved to <body>. delegation means the nodes can move freely. */
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bundle-skip]')) { submit(); return; }
      if (e.target.closest('[data-bundle-close]')) { closeModal(); }
    });

    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (!add || add.disabled) return;
      if (picks.length >= size) { return; }
      var item = add.closest('[data-bundle-item]');
      picks.push({
        vid: add.dataset.vid, price: parseInt(add.dataset.price, 10) || 0,
        pid: item.dataset.pid || item.dataset.title, img: item.dataset.img,
        title: item.dataset.title, variant: add.dataset.variant
      });
      sync();
    });

    if (openBtn) openBtn.addEventListener('click', openModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

    function submit() {
      atc.disabled = true;
      var bundleId = 'box-' + Date.now();
      var note = noteEl ? noteEl.value.trim() : '';
      var byVid = {};
      picks.forEach(function (p) { byVid[p.vid] = (byVid[p.vid] || 0) + 1; });
      var items = Object.keys(byVid).map(function (vid) {
        var props = { _bundle: bundleId };
        if (note) props['Gift note'] = note;
        return { id: parseInt(vid, 10), quantity: byVid[vid], properties: props };
      });
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error(); return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (typeof updateCartCount === 'function') updateCartCount(cart.item_count);
        atc.textContent = 'Added \u2713';
        picks = []; if (noteEl) noteEl.value = '';
        setTimeout(function () { closeModal(); atc.textContent = ctaLabel; atc.disabled = false; sync(); }, 1000);
      }).catch(function () {
        atc.textContent = 'Error \u2014 try again';
        setTimeout(function () { atc.textContent = ctaLabel; atc.disabled = false; }, 1800);
      });
    }
    if (atc) atc.addEventListener('click', submit);
    sync();
  });

  /* ---------- product gallery: swipeable track + synced thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var slides = track ? track.children.length : 0;
    if (!track || slides < 2) return;

    function setActive(n) {
      thumbs.forEach(function (b, idx) { b.classList.toggle('is-active', idx === n); });
      if (thumbs[n] && thumbs[n].scrollIntoView) thumbs[n].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (counter) counter.textContent = (n + 1) + ' / ' + slides;
    }

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: parseInt(b.dataset.thumb, 10) * track.clientWidth, behavior: 'smooth' });
      });
    });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });
  });
})();

/* ---------- hero slideshow + scroll reveals ---------- */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = root.querySelectorAll('.hero-slide');
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('[data-slide-to]');
    var i = 0, timer;

    function setActive(n) {
      if (n === i) return;
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = n;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function scrollTo(n, instant) {
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }
    function start() {
      if (reduced) return;
      stop();
      timer = setInterval(function () { scrollTo(i + 1); }, parseInt(root.dataset.interval, 10) || 6000);
    }
    function stop() { clearInterval(timer); }

    /* sync active slide/dot to whatever the user swiped to */
    var scrollDebounce;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    }, { passive: true });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { stop(); scrollTo(parseInt(d.dataset.slideTo, 10)); start(); });
    });
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    window.addEventListener('resize', function () { scrollTo(i, true); });
    start();
  });

  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.iwt, .carousel, .product-grid, .collections-grid, .contact-layout').forEach(function (el) {
      el.classList.add('will-reveal');
      io.observe(el);
    });
    /* fail-open: content must never stay invisible if the observer misfires
       (theme editor re-renders, prerendering, odd embeds) */
    setTimeout(function () {
      document.querySelectorAll('.will-reveal:not(.is-revealed)').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }, 2500);
  }
})();

/* ---------- flame glow + scent ticker ---------- */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* flame glow follows the pointer */
  document.querySelectorAll('[data-flame-glow]').forEach(function (root) {
    var glow = root.querySelector('.hero-glow');
    if (!glow) return;
    root.addEventListener('mousemove', function (e) {
      var r = root.getBoundingClientRect();
      glow.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      glow.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    });
  });

  /* scent-note ticker */
  document.querySelectorAll('.hero__kicker[data-ticker]').forEach(function (el) {
    var notes = el.dataset.ticker.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (notes.length < 2) return;
    var span = document.createElement('span');
    span.className = 'tick';
    span.textContent = notes[0];
    el.textContent = '';
    el.appendChild(span);
    if (reduced) return;
    var i = 0;
    setInterval(function () {
      span.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % notes.length;
        span.textContent = notes[i];
        span.classList.remove('is-out');
        span.classList.add('is-in');
        setTimeout(function () { span.classList.remove('is-in'); }, 340);
      }, 320);
    }, 2400);
  });
})();

/* ---------- shoppable video carousel: in-view autoplay + tap to unmute ---------- */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-reels]').forEach(function (root) {
    var autoplay = root.hasAttribute('data-reels-autoplay') && !reduced;
    var videos = root.querySelectorAll('.reel__media video');
    if (!videos.length) return;

    videos.forEach(function (v) {
      var media = v.closest('[data-reel-media]');
      var muteBtn = media.querySelector('[data-reel-mute]');
      if (muteBtn) {
        muteBtn.hidden = false;
        muteBtn.addEventListener('click', function () {
          v.muted = !v.muted;
          muteBtn.classList.toggle('is-unmuted', !v.muted);
          if (!v.muted) {
            /* mute every other reel so audio never overlaps */
            videos.forEach(function (other) {
              if (other === v) return;
              other.muted = true;
              var b = other.closest('[data-reel-media]').querySelector('[data-reel-mute]');
              if (b) b.classList.remove('is-unmuted');
            });
            v.play().catch(function () {});
          }
        });
      }
      /* tapping the video toggles play/pause without leaving the page */
      v.addEventListener('click', function () {
        if (v.paused) v.play().catch(function () {});
        else v.pause();
      });
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.intersectionRatio >= 0.6) {
          if (autoplay) v.play().catch(function () {});
        } else {
          v.pause();
          v.muted = true; /* leaving the viewport always silences */
          var b = v.closest('[data-reel-media]').querySelector('[data-reel-mute]');
          if (b) b.classList.remove('is-unmuted');
        }
      });
    }, { threshold: [0, 0.6] });
    videos.forEach(function (v) { io.observe(v); });
  });
})();

/* ---------- marquee: guarantee track width >= 2x viewport ---------- */
(function () {
  'use strict';
  function fill(track) {
    var guard = 0;
    while (track.scrollWidth < window.innerWidth * 2 && guard < 8) {
      track.innerHTML += track.innerHTML; /* doubling keeps the two-identical-halves loop seamless */
      guard++;
    }
  }
  function init() { document.querySelectorAll('.marquee__track').forEach(fill); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init); /* theme editor re-renders */
})();

/* ---------- scent quiz ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-quiz]').forEach(function (root) {
    var poolEl = root.querySelector('[data-quiz-pool]');
    if (!poolEl) return;
    var pool;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    var steps = root.querySelectorAll('[data-quiz-step]');
    var intro = root.querySelector('[data-quiz-intro]');
    var result = root.querySelector('[data-quiz-result]');
    var matches = root.querySelector('[data-quiz-matches]');
    var capture = root.querySelector('[data-quiz-capture]');
    var reveal = root.querySelector('[data-quiz-reveal]');
    var profileEl = root.querySelector('[data-quiz-profile]');
    var form = root.querySelector('.quiz__form');
    var emailEl = root.querySelector('[data-quiz-email]');
    var tagsEl = root.querySelector('[data-quiz-tags]');
    var msgEl = root.querySelector('[data-quiz-msg]');
    var successText = root.dataset.quizSuccess || 'Sent \u2728 your matches are below';
    var baseTag = (root.dataset.quizBaseTag || 'quiz').trim();
    var collected = [];
    var current = -1;

    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) + '/-';
    }
    function show(el) {
      root.querySelectorAll('.quiz__step').forEach(function (s) { s.classList.remove('is-active'); });
      el.classList.add('is-active');
    }
    /* unique tags, ordered by how often they were chosen */
    function topTags() {
      var freq = {};
      collected.forEach(function (t) { t = t.trim().toLowerCase(); if (t) freq[t] = (freq[t] || 0) + 1; });
      return Object.keys(freq).sort(function (a, b) { return freq[b] - freq[a]; });
    }
    function renderMatches() {
      var want = topTags();
      var scored = pool.map(function (p) {
        var tags = (p.tags || []).map(function (t) { return t.toLowerCase(); });
        var score = want.reduce(function (s, t) { return s + (tags.indexOf(t) > -1 ? 1 : 0); }, 0);
        return { p: p, score: score };
      }).sort(function (a, b) { return b.score - a.score; }).slice(0, 3);
      matches.innerHTML = scored.map(function (s) {
        var p = s.p;
        return '<a class="quiz-match" href="' + p.url + '">' +
          (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') +
          '<span class="quiz-match__meta"><span class="quiz-match__title">' + p.title + '</span>' +
          '<span class="quiz-match__price">' + money(p.price) + '</span></span></a>';
      }).join('');
    }
    function revealMatches() { if (reveal) reveal.hidden = false; if (capture) capture.hidden = true; }
    function setMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text; msgEl.hidden = !text;
      msgEl.classList.toggle('is-error', !!isError);
    }
    function finish() {
      renderMatches();
      var top = topTags().slice(0, 3);
      if (profileEl && top.length) profileEl.textContent = 'Your scent profile: ' + top.join(' \u00b7 ');
      if (capture) { capture.hidden = false; if (reveal) reveal.hidden = true; setMsg('', false); }
      else if (reveal) { reveal.hidden = false; }
      show(result);
    }
    function next() {
      current++;
      if (current < steps.length) { show(steps[current]); return; }
      finish();
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = ((emailEl && emailEl.value) || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setMsg('Enter a valid email.', true); return; }
        var tags = [baseTag].concat(topTags()).filter(Boolean).join(', ');
        if (tagsEl) tagsEl.value = tags;
        var btn = form.querySelector('[data-quiz-submit]');
        if (btn) btn.disabled = true;
        setMsg('', false);
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error(); setMsg(successText, false); revealMatches(); })
          .catch(function () {
            /* never trap the customer behind a failed signup — show matches anyway */
            setMsg('Couldn\u2019t save that, but here are your matches.', true); revealMatches();
          })
          .then(function () { if (btn) btn.disabled = false; });
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-start]')) { collected = []; current = -1; next(); return; }
      var ans = e.target.closest('[data-quiz-answer]');
      if (ans) {
        (ans.dataset.tags || '').split(',').forEach(function (t) { t = t.trim(); if (t) collected.push(t); });
        next();
        return;
      }
      if (e.target.closest('[data-quiz-skip]')) { revealMatches(); return; }
      if (e.target.closest('[data-quiz-restart]')) {
        collected = []; current = -1;
        if (emailEl) emailEl.value = '';
        setMsg('', false);
        if (capture) capture.hidden = false;
        if (reveal && capture) reveal.hidden = true;
        show(intro);
      }
    });
  });
})();

/* ---------- drop countdown ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var raw = (root.dataset.deadline || '').trim();
    if (!raw) return;
    /* "YYYY-MM-DD HH:MM" interpreted as IST (+05:30) */
    var iso = raw.replace(' ', 'T') + ':00+05:30';
    var deadline = new Date(iso).getTime();
    if (isNaN(deadline)) return;
    var timer = root.querySelector('[data-countdown-timer]');
    var ended = root.querySelector('[data-countdown-ended]');
    var d = root.querySelector('[data-cd-d]'), h = root.querySelector('[data-cd-h]'),
        m = root.querySelector('[data-cd-m]'), s = root.querySelector('[data-cd-s]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        timer.hidden = true;
        ended.hidden = false;
        clearInterval(iv);
        return;
      }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor(diff / 3600000) % 24);
      m.textContent = pad(Math.floor(diff / 60000) % 60);
      s.textContent = pad(Math.floor(diff / 1000) % 60);
    }
    var iv = setInterval(tick, 1000);
    tick();
  });

  /* ---------- faceted filters (Search & Discovery) ---------- */
  (function () {
    function lock(on) { document.documentElement.classList.toggle('facets-open', on); }
    var isDesktop = function () { return window.matchMedia('(min-width: 861px)').matches; };

    document.addEventListener('click', function (e) {
      // open mobile drawer
      var openBtn = e.target.closest('[data-facets-open]');
      if (openBtn) { var fo = openBtn.closest('[data-facets-form]'); if (fo) { fo.classList.add('is-open'); lock(true); } return; }
      // close mobile drawer (X / scrim)
      var closeEl = e.target.closest('[data-facets-close]');
      if (closeEl) { var fc = closeEl.closest('[data-facets-form]'); if (fc) { fc.classList.remove('is-open'); lock(false); } return; }
      // desktop: toggle a filter dropdown
      var tBtn = e.target.closest('[data-facets-grouptoggle]');
      if (tBtn && isDesktop()) {
        var g = tBtn.closest('[data-facets-group]');
        var form = g.closest('[data-facets-form]');
        var wasOpen = g.classList.contains('is-open');
        form.querySelectorAll('[data-facets-group].is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('[data-facets-grouptoggle]').setAttribute('aria-expanded', 'false'); });
        if (!wasOpen) { g.classList.add('is-open'); tBtn.setAttribute('aria-expanded', 'true'); }
        return;
      }
      // desktop: click outside an open dropdown closes it
      if (isDesktop() && !e.target.closest('.facets__group-body')) {
        document.querySelectorAll('[data-facets-group].is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('[data-facets-grouptoggle]').setAttribute('aria-expanded', 'false'); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var any = false;
      document.querySelectorAll('[data-facets-form].is-open').forEach(function (f) { f.classList.remove('is-open'); any = true; });
      document.querySelectorAll('[data-facets-group].is-open').forEach(function (g) { g.classList.remove('is-open'); });
      if (any) lock(false);
    });

    document.querySelectorAll('[data-facets-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;          // price applies via Apply / Show results
        if (e.target.matches('[data-facets-sort]') || isDesktop()) form.submit();
      });
    });
  })();


  /* ---------- product card: hover image swap (hover devices only) ---------- */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', function (e) {
      var m = e.target.closest && e.target.closest('.product-card__media.has-hover-swap');
      if (!m) return;
      var h = m.querySelector('.product-card__img--hover');
      if (h) h.style.opacity = '1';
    });
    document.addEventListener('pointerout', function (e) {
      var m = e.target.closest && e.target.closest('.product-card__media.has-hover-swap');
      if (!m) return;
      if (e.relatedTarget && m.contains(e.relatedTarget)) return;
      var h = m.querySelector('.product-card__img--hover');
      if (h) h.style.opacity = '0';
    });
  }


  /* ---------- predictive search overlay ---------- */
  (function () {
    var ps = document.querySelector('[data-psearch]');
    if (!ps) return;
    var input    = ps.querySelector('[data-psearch-input]');
    var ghost    = ps.querySelector('[data-psearch-ghost]');
    var rotate   = ps.querySelector('[data-psearch-rotate]');
    var def      = ps.querySelector('[data-psearch-default]');
    var results  = ps.querySelector('[data-psearch-results]');
    var grid     = ps.querySelector('[data-psearch-results-grid]');
    var empty    = ps.querySelector('[data-psearch-empty]');
    var loading  = ps.querySelector('[data-psearch-loading]');
    var viewall  = ps.querySelector('[data-psearch-viewall]');
    var terms = Array.prototype.map.call(ps.querySelectorAll('.psearch__pill'), function (a) { return a.textContent.trim(); }).filter(Boolean);

    var ri = 0, rt = null;
    function startRotate() {
      if (!rotate || terms.length < 2) return;
      stopRotate();
      rt = setInterval(function () { if (input.value) return; ri = (ri + 1) % terms.length; rotate.textContent = terms[ri]; }, 2200);
    }
    function stopRotate() { if (rt) { clearInterval(rt); rt = null; } }

    function open() {
      ps.hidden = false;
      document.documentElement.classList.add('psearch-open');
      setTimeout(function () { input.focus(); }, 60);
      showDefault();
      startRotate();
    }
    function close() { ps.hidden = true; document.documentElement.classList.remove('psearch-open'); stopRotate(); }

    function showDefault() { if (def) def.hidden = false; results.hidden = true; empty.hidden = true; loading.hidden = true; if (ghost) ghost.hidden = !!input.value; }

    var t = null;
    function runSearch(q) {
      if (def) def.hidden = true;
      empty.hidden = true; results.hidden = true; loading.hidden = false;
      if (viewall) viewall.href = '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
      fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=8', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          loading.hidden = true;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var cards = tmp.querySelectorAll('.psearch__card');
          if (!cards.length) { empty.textContent = 'No matches for \u201C' + q + '\u201D.'; empty.hidden = false; results.hidden = true; return; }
          grid.innerHTML = '';
          Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
          results.hidden = false;
        })
        .catch(function () { loading.hidden = true; });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-predictive-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-predictive-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ps.hidden) close(); });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (ghost) ghost.hidden = q.length > 0;
      clearTimeout(t);
      if (!q) { showDefault(); return; }
      t = setTimeout(function () { runSearch(q); }, 250);
    });
  })();

  /* ---------- order tracking (Shopify order lookup) ---------- */
  (function () {
    var root = document.querySelector('[data-track]');
    if (!root) return;
    var form    = root.querySelector('[data-track-form]');
    var orderEl = root.querySelector('[data-track-order]');
    var emailEl = root.querySelector('[data-track-email]');
    var loading = root.querySelector('[data-track-loading]');
    var errorEl = root.querySelector('[data-track-error]');
    var result  = root.querySelector('[data-track-result]');
    var proxy   = (root.getAttribute('data-proxy') || '').trim();
    var account = (root.getAttribute('data-account') || '/account').trim();

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
    function hide(el) { el.hidden = true; }
    function show(el) { el.hidden = false; }
    function pretty(s) { return String(s || '').toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }); }

    function fmtDate(v) {
      if (!v) return '';
      var d = new Date(v);
      if (isNaN(d)) return esc(v);
      try { return d.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true }); }
      catch (e) { return d.toDateString(); }
    }

    function badgeClass(status) {
      var s = (status || '').toLowerCase();
      if (s.indexOf('cancel') > -1 || s.indexOf('rto') > -1 || s.indexOf('return') > -1 || s.indexOf('attempt') > -1 || s.indexOf('unfulfilled') > -1 || s.indexOf('pending') > -1) return 'track-badge--amber';
      if (s.indexOf('deliver') > -1 && s.indexOf('out for') === -1) return 'track-badge--green';
      if (s.indexOf('fulfilled') > -1) return 'track-badge--green';
      if (s.indexOf('out for delivery') > -1) return 'track-badge--rose';
      return 'track-badge--maroon';
    }

    function render(d) {
      var topStatus = d.cancelledAt ? 'Cancelled' : pretty(d.fulfillmentStatus || 'Pending');
      var head = '<div class="track-statusbar">' +
        '<span class="track-badge ' + badgeClass(d.cancelledAt ? 'cancelled' : d.fulfillmentStatus) + '">' + esc(topStatus) + '</span>' +
        '<span class="track-awb">Order ' + esc(d.name || '') + (d.financialStatus ? ' &middot; ' + esc(pretty(d.financialStatus)) : '') + '</span>';
      if (d.cancelledAt) head += '<p class="track-eta">Cancelled ' + fmtDate(d.cancelledAt) + (d.cancelReason ? ' &middot; ' + esc(pretty(d.cancelReason)) : '') + '</p>';
      else if (d.estimatedDeliveryAt) head += '<p class="track-eta">Expected delivery: <strong>' + fmtDate(d.estimatedDeliveryAt) + '</strong></p>';
      head += '</div>';

      var items = '';
      if (d.items && d.items.length) {
        items = '<ul class="track-items">';
        for (var k = 0; k < d.items.length; k++) items += '<li><span>' + esc(d.items[k].title) + '</span><span>&times;' + esc(d.items[k].quantity) + '</span></li>';
        items += '</ul>';
      }

      var links = '';
      (d.tracking || []).forEach(function (t) {
        if (t.url) links += '<a class="track-track-link" href="' + esc(t.url) + '" target="_blank" rel="noopener">' + esc(t.company || 'Track shipment') + (t.number ? ' &middot; ' + esc(t.number) : '') + ' &rarr;</a>';
      });

      var steps = '';
      var events = d.events || [];
      for (var i = 0; i < events.length; i++) {
        var ev = events[i];
        var meta = [];
        if (ev.location) meta.push('<span>' + esc(ev.location) + '</span>');
        if (ev.datetime) meta.push('<span>' + fmtDate(ev.datetime) + '</span>');
        steps += '<li class="track-step' + (i === 0 ? ' track-step--current' : '') + '">' +
          '<h4>' + esc(pretty(ev.status) || 'Update') + '</h4>' +
          (meta.length ? '<div class="track-meta">' + meta.join(' &middot; ') + '</div>' : '') +
          (ev.message ? '<div class="track-meta">' + esc(ev.message) + '</div>' : '') + '</li>';
      }
      var timeline = steps ? '<ul class="track-timeline">' + steps + '</ul>'
        : (links ? '' : '<p class="track-eta" style="margin-top:16px">No tracking updates yet. We\'ll have movement here once your parcel is on its way.</p>');

      result.innerHTML = head + items + (links ? '<div class="track-links">' + links + '</div>' : '') + timeline;
      hide(loading); hide(errorEl); show(result);
    }

    function fail(msg) {
      hide(loading); hide(result);
      errorEl.innerHTML = msg || ("We couldn't find an order with that number and email. Check both and try again, or " +
        '<a href="' + esc(account) + '">sign in to your account &rarr;</a>');
      show(errorEl);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var order = (orderEl.value || '').trim();
      var email = (emailEl.value || '').trim();
      if (!order) { orderEl.focus(); return; }
      if (!email) { emailEl.focus(); return; }
      hide(errorEl); hide(result);

      if (!proxy) {
        fail('Order tracking opens in your account. <a href="' + esc(account) + '">Sign in to view your orders &rarr;</a>');
        return;
      }
      show(loading);
      var sep = proxy.indexOf('?') > -1 ? '&' : '?';
      fetch(proxy + sep + 'name=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) { render(d); } else { fail(); } })
        .catch(function () { fail("Something went wrong fetching your order. Please try again in a moment."); });
    });
  })();

})();

/* ============================================================
   CART DRAWER
   Re-renders itself from the Section Rendering API so all money,
   discounts and stock come from Liquid. Cart page logic is untouched.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  var lastFocus = null;

  function panel() { return root.querySelector('[data-cd-panel]'); }

  function open() {
    if (!root.hidden && root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('cd-open');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var close = root.querySelector('[data-cd-close]');
      if (close && close.focus) close.focus();
      animateShipbar();
    });
    document.addEventListener('keydown', onKey);
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('cd-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var p = panel();
    if (!p) return;
    var items = p.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function animateShipbar() {
    var fill = root.querySelector('[data-cd-shipfill]');
    if (!fill) return;
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.width = fill.dataset.pct + '%'; });
    });
  }

  /* pull a fresh copy of this section and swap the panel in */
  function refresh() {
    root.classList.add('is-busy');
    return nativeFetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
        if (!fresh) return;
        root.innerHTML = fresh.innerHTML;
        animateShipbar();
      })
      .catch(function () {})
      .then(function () {
        root.classList.remove('is-busy');
        return nativeFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          setCount(cart.item_count);
          return cart;
        }).catch(function () {});
      });
  }

  function changeLine(line, qty) {
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refresh);
  }

  /* open: header icons, and after anything is added to the cart */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); }
  });

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* Any add to cart anywhere in the theme (PDP form, quick add, bundle and set builders)
     opens the drawer — they all go through /cart/add.js. */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1;
    return nativeFetch.apply(this, arguments).then(function (res) {
      if (isAdd && res.ok) {
        setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:added')); }, 0);
      }
      return res;
    });
  };

  var addTimer = null;
  document.addEventListener('cart:added', function () {
    clearTimeout(addTimer);
    addTimer = setTimeout(function () { refresh().then(open); }, 120);
  });

  /* quantity, remove, variant swap, upsell, carousel — all inside the drawer only */
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-cd-step]');
    if (step) {
      var input = step.parentElement.querySelector('[data-cd-qty]');
      var next = Math.max(0, parseInt(input.value || '1', 10) + parseInt(step.dataset.cdStep, 10));
      input.value = next;
      changeLine(parseInt(input.dataset.cdQty, 10), next);
      return;
    }
    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();
      var line = rm.closest('[data-cd-line]');
      if (line) line.remove();
      changeLine(parseInt(rm.dataset.cdRemove, 10), 0);
      return;
    }
    var add = e.target.closest('[data-cd-add]');
    if (add && add.tagName === 'BUTTON') {
      e.preventDefault();
      add.disabled = true;
      nativeFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(add.dataset.cdAdd, 10), quantity: 1 })
      }).then(function () { add.disabled = false; return refresh(); });
      return;
    }
    var nav = e.target.closest('[data-cd-scroll]');
    if (nav) {
      var track = root.querySelector('[data-cd-xtra-track]');
      if (track) track.scrollBy({ left: parseInt(nav.dataset.cdScroll, 10) * track.clientWidth * 0.86, behavior: 'smooth' });
    }
  });

  root.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) { changeLine(parseInt(qty.dataset.cdQty, 10), Math.max(0, parseInt(qty.value || '0', 10))); return; }

    var swap = e.target.closest('[data-cd-swap]');
    if (swap) {
      var key = swap.dataset.cdSwap;
      var count = parseInt(swap.dataset.qty, 10) || 1;
      swap.disabled = true;
      nativeFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function () {
          return nativeFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(swap.value, 10), quantity: count })
          });
        })
        .then(refresh);
    }
  });

  /* discount codes — same /cart/update.js approach as the cart page */
  function appliedCodes(box) { return (box.dataset.applied || '').split(',').filter(Boolean); }
  function postDiscount(codes) {
    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  root.addEventListener('click', function (e) {
    var box = root.querySelector('[data-cd-discount]');
    if (!box) return;
    var msg = box.querySelector('[data-cd-discount-msg]');
    function setMsg(text, ok) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.classList.toggle('is-ok', !!ok);
    }

    var apply = e.target.closest('[data-cd-discount-apply]');
    if (apply) {
      var input = box.querySelector('[data-cd-discount-input]');
      var code = (input.value || '').trim();
      if (!code) return;
      var codes = appliedCodes(box);
      if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { setMsg('Code already applied.'); return; }
      apply.disabled = true;
      setMsg('');
      postDiscount(codes.concat(code)).then(function (cart) {
        var entry = (cart.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (entry && entry.applicable) return refresh();
        return postDiscount(codes).then(function () {
          setMsg('That code isn\u2019t valid or doesn\u2019t apply to this cart.');
          apply.disabled = false;
        });
      }).catch(function () {
        setMsg('Couldn\u2019t apply the code. Try again.');
        apply.disabled = false;
      });
      return;
    }

    var drop = e.target.closest('[data-cd-discount-remove]');
    if (drop) {
      drop.disabled = true;
      var left = appliedCodes(box).filter(function (c) { return c !== drop.dataset.cdDiscountRemove; });
      postDiscount(left).then(refresh);
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-cd-discount-input]')) {
      e.preventDefault();
      var apply = root.querySelector('[data-cd-discount-apply]');
      if (apply) apply.click();
    }
  });
})();
